import exportPlans from "./export";
import findPlan from "./find";
import searchPlans from "./search";
export const baseUrl = "/company/:company_id/plans";
export default (axiosConfig, options) => ({
  export: exportPlans(axiosConfig, options),
  find: findPlan(axiosConfig, options),
  search: searchPlans(axiosConfig, options)
});